export default {
  API_BASE_URL: process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL as string,
  S3_BASE_URL: process.env.NEXT_PUBLIC_REACT_APP_S3_BUCKET_BASE_URL as string,
  GOOGLE_API_KEY: process.env.NEXT_PUBLIC_REACT_APP_GOOGLE_API_KEY as string,
};
